import {formatter, request} from '@/utils/request';

export namespace CustSysAdd {
  export const Path = {
    Query: '/expenseapi/custSysAdd/query',
    Export: '/expenseapi/custSysAdd/export',
    Get: '/expenseapi/custSysAdd/get',
    Post: '/expenseapi/custSysAdd/post',
    search: '/expenseapi/custSysAdd/search',
    ajaxSearch: '/expenseapi/custSysAdd/ajaxSearch',
  };

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.CustSysAdd>>(Path.Query, formatter(options));
  }

  export async function exportEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.CustSysAdd>>(Path.Export, formatter(options));
  }


  export async function get(code: string) {
    const options = {
      method: 'GET',
      body: {
        code,
      },
    };
    return request<API.ResponseResult<API.CustSysAdd>>(Path.Get, formatter(options));
  }

  export async function post(body: API.SoldToGroupEntity) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<any>>(Path.Post, formatter(options));
  }

  export async function search(body: API.CustSysAddSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.CustSysAdd[]>>(Path.search, formatter(options));
  }

  export async function ajaxSearch(body: API.CustSysAddSearchParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.CustSysAdd[]>>(Path.ajaxSearch, formatter(options));
  }

}
